import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { SaleOfferDepartureSerialNumber } from '../sale-offer-departure-serial-number';

export class SaleOfferDepartureSerialNumberBuilder {

  static fromJson(json): SaleOfferDepartureSerialNumber {
    return (json) ? new SaleOfferDepartureSerialNumber(
      json.hash,
      json.serialNumber,
      json.saleOfferLineHash,
      json.saleOfferLineType,
      json.saleOfferLineProductName,
      json.saleOfferLineProductCode,
      json.saleOfferLineProductDescription,
      json.saleOfferLineProductNeedSerialNumber,
      json.saleOfferLineComplementName,
      json.saleOfferLineComplementCode,
      json.saleOfferLineComplementDescription,
      json.saleOfferLineComplementNeedSerialNumber
    ) : null;
  }

  static fromJsonList(list): SaleOfferDepartureSerialNumber[] {
    return (isArray(list)) ? sortByString('serialNumber', mapCollection(SaleOfferDepartureSerialNumberBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-departure-serial-number.builder.ts